import React, { useState, useEffect } from 'react'
import { Row, Col, Container, Dropdown, Nav, Tab, OverlayTrigger, Tooltip, Button, Modal, ModalFooter } from 'react-bootstrap'
import { Link, useNavigate, Route } from 'react-router-dom'
// images
import sideImage from '../assets/images/getappimg/img.webp'
import StoreBadges from './StoreBadges'


const GetApp = ({ }) => {

    useEffect(() => {
    }, [])


    return (
        <div style={{ background: `${process.env.REACT_APP_PROJECT_STATUS === "1" ? "#FFFFFF" : "#F5F7FE"}`, paddingTop: "70px", paddingBottom: "70px" }}>
            <Container>
                <Row className="align-items-center g-4">
                    <Col xs={12} md={6} className="text-center text-md-start">
                        <img src={sideImage} className="img-fluid" alt="header-bg" />
                    </Col>
                    <Col xs={12} md={6}>
                        <h1>Get Access From</h1>
                        <h1 style={{ marginTop: "-13px" }}><Link to="#" className="mt-0">Anywhere</Link></h1>
                        <p className="pt-3 pb-3">Take classes on the go with the educrat app. Stream or download to watch on the plane, the subway, or wherever you learn best.</p>
                        <StoreBadges width={150} height={44} />
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default GetApp
